<template>
    <div class="loader">
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
            <g clip-path="url(#clip0_6590_88508)">
                <path d="M48.7191 7.31686C48.5594 3.16525 45.0435 -0.12799 40.9627 0.652194C34.4088 1.90521 28.146 4.46259 22.5572 8.20001C14.875 13.3374 8.76698 20.5034 4.91127 28.9023C1.05556 37.3012 -0.396935 46.6045 0.715072 55.779C1.82708 64.9535 5.46007 73.6404 11.2107 80.875C16.9612 88.1096 24.6044 93.6088 33.2915 96.7622C41.9785 99.9155 51.3696 100.599 60.4219 98.7382C69.4742 96.8769 77.8335 92.5432 84.5717 86.2182C89.4737 81.6168 93.3782 76.0925 96.0776 69.9902C97.7584 66.1907 95.3434 62.0224 91.3348 60.9301C87.3263 59.8378 83.2593 62.2599 81.3362 65.9427C79.5291 69.4031 77.1468 72.5524 74.2746 75.2484C69.564 79.6702 63.7201 82.6998 57.3917 84.0011C51.0633 85.3023 44.4981 84.8241 38.4251 82.6196C32.352 80.4152 27.0087 76.5707 22.9886 71.513C18.9684 66.4554 16.4286 60.3825 15.6512 53.9687C14.8738 47.5548 15.8892 41.051 18.5847 35.1794C21.2802 29.3078 25.5503 24.2981 30.9209 20.7066C34.1954 18.5168 37.8009 16.9064 41.5799 15.9267C45.6016 14.8841 48.8788 11.4685 48.7191 7.31686Z" fill="#183147"/>
            </g>
            <defs>
                <clipPath id="clip0_6590_88508">
                    <rect width="100" height="100" rx="50" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    </div>
</template>

<script setup>

</script>

<style scoped>

</style>
